import client from '../client'

export async function sendMessage({ conversationId, text, isFile, fileType, fileSize, fileKey }) {
  return client(`${process.env.NEXT_PUBLIC_CHAT_DOMAIN}/api/Chat/SendMessage`, {
    headers: { 'content-type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({
      conversationId,
      text,
      isFile,
      fileType,
      fileSize,
      fileKey,
    }),
  })
}
